import { render } from "./TagWithTooltip.vue?vue&type=template&id=07289eda"
import script from "./TagWithTooltip.vue?vue&type=script&lang=js"
export * from "./TagWithTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__